import {Postnummer,} from '../../../models';
import RequestService, {getQueryURL} from '../requestService';
import {client} from '../../client';
import {store} from '../../../app/store';
import {handleError} from '../../../features/layout/layoutSlice';
import {ImportPostnummerVinduFerdigModel} from '../../../models/importPostnummerVinduFerdigModel';

export class PostnummerService extends RequestService<Postnummer, 'postnummer'>
{
    import = async (param: ImportPostnummerVinduFerdigModel, fileContent: Blob) =>  {
        try {
            const buffer = await fileContent.arrayBuffer();
            const res = await client.post<{}>(getQueryURL(`${this.serviceName}/import`, param), buffer);
            return {success: true, msg: res};
        } catch (err) {
            await store.dispatch(handleError(err as Error));
            return {success: false, msg: (err as Error).message};
        }
    };
}
